export default function Loader({ isLoading = true }) {
  return (
    <center id="feedLoader" className={isLoading ? 'true' : ''}>
      <img alt="Loader" src={require('../assets/images/loader.gif').default} />
    </center>
  );
}
